'use client';

import React from 'react';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { useContentSize } from '@osmosis/nextjs-components/context/ContentSizeContext';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';

type Props = {
  children: React.ReactNode;
};

/**
 * Client wrapper for the answers page upper-right sidebar that applies
 * container-width-based responsive classes instead of viewport-based ones.
 */
const AnswersUpperRight = ({ children }: Props) => {
  const { getClassValue } = useContentSize();

  const minHeightClassname = getClassValue({
    defaultClasses: 'min-h-80 md:min-h-96',
    breakpoints: { md: 'min-h-96', base: 'min-h-80' },
  });

  const marginClassname = getClassValue({
    defaultClasses: 'my-4 xl:my-0',
    breakpoints: { xl: 'my-0', base: 'my-4' },
  });

  return (
    <Box
      data-testid="learn-upper-right-wrapper"
      style={{ gridArea: 'uppersidebar' }}
      className={cn('relative h-full', minHeightClassname, marginClassname)}
    >
      <Box className="flex w-full flex-col">
        <Box className="mb-2" data-testid="sidebar">
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AnswersUpperRight;
